import classnames from 'classnames';
import PropTypes from 'prop-types';

import Button from 'shared/components/button/Button';
import { getText } from 'shared/utils/Text';

import styles from './index.module.scss';

const TrendViewToolbar = ({
  onChangeTrendTime,
  getTrendMinutes,
  isLocked,
  trendTime,
}) => {
  const times = [
    [30, 'toolbar-trend-button-30min'],
    [60, 'toolbar-trend-button-1tim'],
    [120, 'toolbar-trend-button-2tim'],
  ];

  const trendMinutes = getTrendMinutes();

  return (
    <>
      {times.map(([time, textKey]) => (
        <Button
          className={classnames(styles.btn, {
            [styles.active]: time === trendMinutes,
          })}
          disabled={isLocked}
          key={textKey}
          onClick={() => onChangeTrendTime(time)}
        >
          {getText(textKey)}
        </Button>
      ))}

      <div className={styles.trendTime}>
        {trendTime ? `${getText('toolbar-trend-updated')} ${trendTime}` : ''}
      </div>
    </>
  );
};

TrendViewToolbar.propTypes = {
  getTrendMinutes: PropTypes.func.isRequired,
  isLocked: PropTypes.bool,
  onChangeTrendTime: PropTypes.func.isRequired,
  trendTime: PropTypes.string,
};

export default TrendViewToolbar;
